import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useWorkspaces } from 'app/components/companies/workspaces/useWorkspaces'
import { WorkspacesShadcnComponent } from 'app/components/companies/workspaces/WorkspacesShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'

// observer: the <Navigate> redirect is gated on useCheckPermission, which reads
// the current user's permissions from an observable store and resolves
// asynchronously (undefined/false until the store loads, then re-rendering).
// Without observer, when permissions resolve after mount the redirect for an
// unauthorized user would not fire until an unrelated re-render, leaving a page
// visible that the user should not see (TRK-6022).
const Workspaces = observer(function Workspaces(): React.ReactElement {
  const checkPermission = useCheckPermission()
  // Call all hooks before any conditional return. useCheckPermission resolves
  // asynchronously (returning false/undefined until the store loads, then
  // re-rendering), so gating useWorkspaces behind the early <Navigate> return
  // changed the hook count between renders and crashed the route with "rendered
  // fewer hooks than expected" — a blank page that flashed before content
  // (TRK-5214).
  const props = useWorkspaces()

  if (!checkPermission(`org:pages:companies`)) {
    return <Navigate to="/" replace />
  }

  return <WorkspacesShadcnComponent {...props} />
})

export default Workspaces
